import React, { Component } from 'react'

export const controlled = spec => Cmp =>
  class Controlled extends Component {
    constructor(...args) {
      super(...args)
      this.state = Object.keys(spec).reduce((state, prop) => {
        state[prop] = this.props[prop]
        if (
          typeof spec[prop] === 'function' &&
          // not an anonymous function
          spec[prop].name &&
          // not an anonymous function defined as new Function()
          spec[prop].name !== 'anonymous' &&
          // kinda useless check but valid for babel environment
          // Babel explicitly names function
          // {value: function (){}} --> {value: function value (){}}
          // this would mean props are missing one field and having a wrong type for `value`
          spec[prop].name !== prop
        ) {
          state[spec[prop].name] = (...args) =>
            this.setState({ [prop]: spec[prop](...args) })
        } else if (typeof spec[prop] === 'string') {
          state[spec[prop]] = value => this.setState({ [prop]: value })
        } else {
          throw new Error(
            'Invalid @controlled spec, "' +
              prop +
              '" suppose to be a named function or string'
          )
        }
        return state
      }, {})
    }

    render() {
      return <Cmp {...this.props} {...this.state} />
    }
  }
